import { render, staticRenderFns } from "./TablaErroresPaquete.vue?vue&type=template&id=1b0bbcc5"
import script from "./TablaErroresPaquete.vue?vue&type=script&lang=js"
export * from "./TablaErroresPaquete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports